import colors from '../theme/colors';

export default function Spinner({ size = 'md', color = 'white' }) {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-2',
    lg: 'w-8 h-8 border-4'
  };

  const colorClasses = {
    white: colors.spinner.white,
    blue: colors.spinner.blue,
    gray: colors.spinner.gray,
    primary: colors.spinner.primary,
  };

  return (
    <div
      className={`inline-block ${sizeClasses[size]} ${colorClasses[color]} rounded-full animate-spin`}
      role="status"
      aria-label="Loading"
    />
  );
}
